import { Parameter } from '../models';

export function returnMapObject(obj: any): Array<Parameter> {
    return Object.keys(obj).map((key): Parameter => {
        return { id: key, nombre: obj[key] };
    });
}
export function returnMapObjectImpulso(obj: any): Array<Parameter> {
    return obj.map((x: any) => {
        return { id: x.i_pk_id.toString() || x.ID, nombre: x.vc_nombre || x.País };
    });
}
export function getBase64(file: Blob): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(reader.result);
        };
        reader.onerror = (error) => {
            reject(error);
        };
    });
}
